<div class="hidden md:block label bg-blue-950 w-100">
  <h6 class="text-white fs-6 ml-3 p-1 mb-0">
    @if (branding) {
    Ministero dell'ambiente e della Sicurezza Energetica
    } @else {
    Lorem ipsum dolor sit amet
    }
  </h6>
</div>

<div class="header">

  <!-- SINISTRA -->
  <div class="header-left">
    @if (branding) {
    <div class="imgPnr">
      <img src="assets/pnr-nero.png" alt="pnr" class="logo">
    </div>
    <div class="imgContainer">
      <img src="assets/stella2.png" alt="Logo Stella" class="logo">
    </div>
    } @else {
    <span class="logo-placeholder">Lorem ipsum</span>
    <span class="logo-placeholder">Dolor</span>
    }
    <div class="title hidden md:block">
      <h1>Portale della fornitura</h1>
      <span>Monitoraggio Esecutivo</span>
    </div>
  </div>

  <!-- DESTRA - LOGGATO -->
  @if (user$ | async; as user) {
  <div class="login-box" tabindex="0">

    <!-- TRIGGER -->
    <button class="user-trigger" type="button" (click)="toggleDropdown()">

      <div class="login-icon">
        <i class="fa fa-user"></i>
      </div>

      <span class="user-name hidden md:block">
        {{ user.fullName || user.username }}
      </span>

      <i class="fa fa-chevron-down caret"></i>
    </button>

    <!-- DROPDOWN -->
    @if(isDropdownOpen){
    <div class="user-dropdown">

      <div class="user-info">
        <strong>{{ user.fullName || user.username }}</strong>
        <small>{{ user.email }}</small>
      </div>

      <button class="dropdown-item logout" type="button" (click)="logout()">
        <i class="fa fa-right-from-bracket"></i>
        Logout
      </button>

    </div>
    }
  </div>
  }

  <!-- NON LOGGATO -->
  <ng-template #notLogged>
    <div class="login-box">
      <button class="user-trigger" type="button" (click)="login()">
        <div class="login-icon">
          <i class="fa fa-user"></i>
        </div>
        <span class="user-name">Accedi</span>
      </button>
    </div>
  </ng-template>

</div>